'use strict'

ls_ttl = require 'localstorage-ttl'
tracky = require '../../../../../../../src/frontend/helper/general/m_trackEvent'
{ isEmpty } = require '../../../../../../../src/frontend/helper/general/m_underscore_replacements'
{ getLatLngPayload, fixLocationCookies }  = require '../../../../../../../src/frontend/helper/search/helper/m_location_helper'

template = require '../templates/cards.html.mustache'
ttl_ms = 1000 * 60 * 60

setCards = (data) ->
  noFollowSubNavLinks = Groupon.LS.experiments.noFollowSubNavLinks

  for own key, value of data
    $navContainer = $("#subnav-#{ key }-tab")

    $subNavCardatron = $navContainer.find '.subnav-cardatron'
    if $subNavCardatron.length
      if isEmpty(value) or isEmpty(value.cards)
        tracky 'ls-cardatron-render-error', { err: "#{key} response doesn't contain cards" }
        $subNavCardatron.remove()
      else
        tilesLeft = 4 - $navContainer.find('.subnav-categories').length

        cuiClass = switch tilesLeft
          when 4 then 'cui-four-up'
          when 3 then 'cui-three-up'
          when 2 then 'cui-two-up'
          when 1 then 'cui-one-up'

        value.cards = value.cards.slice(0, tilesLeft)
        value.cards.noFollowSubNavLinks = noFollowSubNavLinks
        rendered = template.render(value)
        $subNavCardatron.replaceWith(rendered)
        $subNavCardatron = $navContainer.find('.subnav-cards').addClass(cuiClass)

  Groupon.Utils.lazyLoadImages '.lazy-load'
  return

error = (err = {}) ->
  tracky 'ls-cardatron-error', { err }

getCardatronCards = ->
  ell = fixLocationCookies(Cookie.get('ell'))
  cll = fixLocationCookies(Cookie.get('cll'))
  division = Groupon.division?.id or ''
  storageKey = 'sls_cardatron_cards'
  brand = $('head').data('brand')

  try
    cacheData = ls_ttl.get storageKey

  if cacheData? and cacheData.cards? and cacheData.division is division and cacheData.brand is brand
    if cacheData.cll is cll and cacheData.ell is ell
      setCards cacheData.cards
      return

  $.ajax {
    type: 'GET'
    url: [ Groupon.endpoints?.cards, 'v1' ].join '/'
    headers: { 'x-ls-locale': I18n.locale, 'x-lat-lng': getLatLngPayload() }
    timeout: 5000
    error: error
    success: ({ data, err }) ->
      if err?
        return error { err }

      unless data and Object.keys(data).length
        return error()

      cacheValue = {
        division
        cll
        ell
        brand: brand
        cards: data
      }

      try
        ls_ttl.set storageKey, cacheValue, ttl_ms
      setCards data
  }
  return

module.exports = {
  getCardatronCards
}
